const InitSchoolPeriod = (schoolPeriod) => {
  const newSchoolPeriod = ('0000' + schoolPeriod).substr(-4)
  let str = ''
  const arr = newSchoolPeriod.split('')
  if (arr[3] == '1') {
    str += '幼儿园、'
  }
  if (arr[2] == '1') {
    str += '小学、'
  }
  if (arr[1] == '1') {
    str += '初中、'
  }
  if (arr[0] == '1') {
    str += '高中、'
  }
  str = str.slice(0, str.length - 1)
  return str
}

const InitOrgSts = (v) => {
  switch (Number(v)) {
    case 1:
      return '运营中'
      break
    case 2:
      return '已停止合作'
      break
  }
}

const InitOrgType = (orgType) => {
  switch (Number(orgType)) {
    case 1:
      return '民企'
      break
    case 2:
      return '国企'
      break
    case 3:
      return '个体'
      break
    case 4:
      return '其他'
      break
  }
}

// 数字三位一逗号
const formatNumber = (n) => {
  if (n && n != '') {
    var b = (!isNaN(n * 1) ? n * 1 : 0).toFixed(2)
    var c = b.split('.')[1] == '00' ? parseInt(b) + '' : b + ''
    return c.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
  } else {
    return 0
  }
}

export { InitSchoolPeriod, InitOrgSts, InitOrgType, formatNumber }
